<template>
  <div class="news_page">
    <div class="banner">
      <img src="../assets/images/news_banner.png" alt="" />
    </div>
    <div class="btn_box">
      <div class="btn_body">
        <div class="btns">
          <!-- 	<div class="btn" :class="tabIndex===item?'btn_act':''" v-for="(item,index) in btns" :key="index"
						@click="changeTab(item)">{{item}}
					</div> -->
        </div>
        <div class="goback">
          <span @click="$router.push('/Home')">首页</span> >
          <span @click="goNews()"> {{ pageTitle }}</span> >
          <span> 详情</span>
        </div>
      </div>
    </div>
    <div class="hyrd_box">
      <div class="list_box">
        <div
          style="
            padding-bottom: 34px;
            border-bottom: 1px solid #cecece;
            margin-bottom: 39px;
          "
        >
          <p class="news-details-name">{{ newsDetail.newsHead }}</p>
          <p class="news-details-time">
            发布时间: {{ newsDetail.year }}-{{ newsDetail.month }}-{{
              newsDetail.day
            }}
          </p>
        </div>
        <div class="news-content" v-html="newsDetail.newsDetail"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "news",
  data() {
    return {
      newsDetail: {},
    };
  },
  computed: {
    pageTitle() {
      return this.$route.query.type == 2 ? "企业文化" : "新闻动态";
    },
  },
  mounted() {},
  created() {
    this.getNewsDetail();
  },
  methods: {
    goNews() {
      this.$router.push({
        path: "/News",
        query: { type: this.$route.query.type },
      });
    },
    // SEO：动态更新浏览器标签页标题与描述（爬虫侧由服务端渲染页处理）
    updateSeo() {
      if (this.newsDetail.newsHead) {
        document.title = this.newsDetail.newsHead + ' - 佳家康医疗集团';
      }
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = this.newsDetail.newsAbstract || '';
    },
    getNewsDetail() {
      this.$api.getNewsDetail({ id: this.$route.params.id }).then(({ data }) => {
        this.newsDetail = data.data;
        this.updateSeo();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news_page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .btn_box {
    width: 100%;
    height: 64px;
    background-color: #f0f1f5;

    .btn_body {
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btns {
        width: 50%;
        height: 64px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .btn {
          width: auto;
          padding: 5px 10px;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, 1);
          margin-right: 15px;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            transition: all 0.3s;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
          }
        }

        .btn_act {
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
        }
      }

      .goback {
        width: auto;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span {
          cursor: pointer;

          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }

  .hyrd_box,
  .gsdt_box {
    width: 100%;
    min-height: 300px;
    height: auto;
    box-sizing: border-box;

    .list_box {
      width: 100%;
      max-width: 1400px;
      padding: 20px;
      box-sizing: border-box;
      height: auto;
      margin: 0 auto;
      .news-ul {
        padding-top: 119px;
      }
      .news-ul li {
        // height: 455px;
        margin-bottom: 140px;
      }
      .news-info {
        // width: 517px;
      }
      .news-text {
        color: #2a2a2a;
        text-align: justify;
        line-height: 20px;
      }
      .news-title {
        font-size: 20px;
        color: #2a2a2a;
        margin-bottom: 20px;
      }
      .news-right .news-time {
        text-align: right;
      }
      .news-day {
        font-size: 58px;
        color: #5754f2;
        line-height: 60px;
        padding-top: 10px;
      }
      .news-time {
        margin-bottom: 16px;
      }
      .news-right .news-text {
        margin-right: 90px;
      }
      .news-details-name {
        font-size: 20px;
        line-height: 28px;
        padding: 45px 0 6px 0;
        text-align: center;
        font-size: 26px;
        color: #4077ae;
      }
      .news-details-time {
        color: #979797;
        font-size: 16px;
        text-align: center;
        margin-top: 23px;
      }
      .news-content img,
      .news-content video {
        width: 770px;
        height: 455px;
        display: block;
        margin: 0 auto;
        margin-bottom: 25px;
      }
      .news-content {
        font-size: 16px;
        color: #393939;
        text-align: justify;
        // font-size: 16px !important;
        line-height: 40px !important;
        margin-bottom: 35px !important;
      }
    }
  }
}
</style>